// REACT, ROUTER & REDUX
import React, { MouseEventHandler, useState } from "react";

// COMPONENTS & FUNCTIONS
import { formatLargeNumbers } from "../../functions/textFormatHandler";

// INTERFACES
import { CalculatorFieldSetProps } from "../../interface/propTypesInterface";

// NPM IMPORTS
import * as FaIcons from "react-icons/fa";

/*
CALCULATORFIELDSET COMPONENT INFORMATION

*/

export default function CalculatorFieldset(props: CalculatorFieldSetProps) {
  // ::::: CONSTANTS :::::
  const {
    bq,
    handleInputs,
    handleUnits,
    handleLock,
    handleRemoveInput,
    className,
  } = props;
  // ::::: USEHOOKS :::::
  const [isLocked, setisLocked] = useState(false);

  // console.log(bq);
  // ::::: FUNCTIONS :::::
  const lockInput = (targetName: string) => {
    handleLock!(targetName, isLocked);
    setisLocked(!isLocked);
  };

  const removeInput = (targetId: string) => {
    handleRemoveInput!(targetId);
  };

  const handleLabelClick = (
    e: React.MouseEvent<HTMLLabelElement, MouseEvent>
  ) => {
    const target = e.target as HTMLLabelElement;
    const selectMenu = document.getElementById(
      target.htmlFor
    ) as HTMLSelectElement;
    console.log(selectMenu);
  };

  // ::::: JSX :::::
  return (
    <fieldset className={className}>
      <label>
        {bq.name.replaceAll("_", " ")}{" "}
        {bq.symbol !== "" && "(" + bq.symbol + ")"}
        {bq.toolTip && (
          <span className="tooltip" data-tip={bq.toolTip}>
            ?
          </span>
        )}
      </label>
      {bq.datavalues == undefined ? (
        <input
          placeholder={bq.name.replaceAll("_", " ")}
          aria-label={bq.name}
          onChange={handleInputs}
          value={formatLargeNumbers(bq.value)}
          name={bq.name}
          id={bq.id}
          type={bq.type}
          inputMode="decimal"
          autoComplete="off"
          autoCorrect="off"
          className={isLocked ? "locked" : ""}
          disabled={isLocked ? true : false}
        />
      ) : (
        <label
          htmlFor={bq.id}
          aria-label={bq.name}
          className="data-list"
          onClick={handleLabelClick}
          tabIndex={-1}
        >
          <span>{formatLargeNumbers(bq.value)}</span>
          <select
            id={bq.id}
            name={bq.id}
            defaultValue={formatLargeNumbers(bq.value)}
            className="custom-select"
            aria-label={bq.name}
            onChange={handleInputs}
          >
            {bq.datavalues!.map((data, index) => {
              return (
                <option key={`${data.label}_${index}`} value={data.value}>
                  {data.label}
                </option>
              );
            })}
          </select>
        </label>
      )}
      <div data-tooltip={bq.units.length <= 1 ? "" : "select unit"}>
        <select
          id={`units-${bq.id}`}
          style={{ width: "100%" }}
          name="calculator_units"
          disabled={bq.units.length <= 1 ? true : false}
          className={
            bq.units.length <= 1
              ? "calculator__units no-dropdown"
              : "calculator__units"
          }
          defaultValue={bq.selectedUnit}
          onChange={(e) => {
            handleUnits(bq, e);
          }}
        >
          {bq.units.map((unit, index) => {
            return (
              <option key={`${unit.name}_${index}`} value={unit.name}>
                {unit.name}
              </option>
            );
          })}
        </select>
      </div>

      {/* If handleLock exists show this button */}
      {handleLock && (
        <button
          id={`lock-${bq.id}`}
          className={`calculator__fieldset-button svg-button ${
            isLocked ? "locked" : ""
          }`}
          type="button"
          onClick={() => lockInput(bq.id)}
          name={bq.name}
          data-tooltip="calculate field"
          tabIndex={-1}
        >
          <FaIcons.FaCalculator className={isLocked ? "locked" : ""} />
        </button>
      )}
      {/* If remove input exists show this button */}
      {handleRemoveInput && (
        <button
          className="calculator__fieldset-button svg-button"
          type="button"
          onClick={() => removeInput(bq.id)}
          name={bq.name}
          data-tooltip="Remove field"
        >
          <FaIcons.FaTrash />
        </button>
      )}
    </fieldset>
  );
}
